import React, { useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSearch } from '@fortawesome/free-solid-svg-icons';
import './FilesSearchBar.scss';

const FilesSearchBar = ({onSearch}) => {
    const [query, setQuery] = useState('');

    const handleChange = (e) => {
        setQuery(e.target.value);
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        onSearch(query);
    };

  return (
    <form className="files-search-bar" onSubmit={handleSubmit}>
      <input 
        type="text" 
        placeholder="Search files and folders..." 
                value={query} 
                onChange={handleChange}  />
      <button type='submit' className='btn btn-sm p-0'><FontAwesomeIcon icon={faSearch} /></button>
    </form>
  );
};

export default FilesSearchBar;